import { render } from "./OpenMediaFile.vue?vue&type=template&id=a1e0acdc&scoped=true"
import script from "./OpenMediaFile.vue?vue&type=script&lang=js"
export * from "./OpenMediaFile.vue?vue&type=script&lang=js"

import "./OpenMediaFile.vue?vue&type=style&index=0&id=a1e0acdc&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a1e0acdc"]])

export default __exports__